import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
//引入vueRouter
import VueRouter from 'vue-router'

import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '/src/assets/css/base.css'

Vue.config.productionTip = false


// step3：使每次请求都会带一个 /api 前缀 
axios.defaults.baseURL = '/api'
//增加拦截器，给所有请求的请求头中加入token
axios.interceptors.request.use(config=>{
  //config.headers.token = window.localStorage.getItem("token");
  return config;
})

import GlobeConstant from './assets/js/GlobeConstant.js';
import GlobeCommon from './assets/js/GlobeCommon.js';
Vue.prototype.GlobeConstant = GlobeConstant;

Vue.prototype.$axios = axios

window.addEventListener("visibilitychange",function(){ //这个办法是监测浏览器窗口发生变化的时候执行
  if (document.hidden === false && GlobeCommon.userId != window.localStorage.getItem("userId")) {
    window.location.reload() 
    GlobeCommon.userId = window.localStorage.getItem("userId"); //只有当初始创立的aaa不等于localStorage外面的userId的时候去笼罩掉这个aaa
  }else {
    GlobeCommon.userId = window.localStorage.getItem("userId");
  }
  //不笼罩的话aaa永远都是咱们设的初始值
});


axios.interceptors.response.use((response) => {
  //特殊错误处理，状态为10时为登录超时
  if (response.data.message === '登录超时，请重新登录！') {
    const storage = window.localStorage;
    storage.clear();
    setTimeout(()=>{
      router.push("/login")
    },3000)
    
  } 
  return response;
}, function (error) {
  return Promise.reject(error);
});

Vue.prototype.$isMobile=function(){
   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
}

//使用vueRouter
Vue.use(VueRouter)
Vue.use(ElementUI)

new Vue({
  el: "#app",
  render: h => h(App),
  router:router,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
})
